import clsx from 'clsx';

import { COLORS } from '~/src/common/theme';

import { IconName } from './Icon.d';
import styles from './Icon.module.scss';

interface Props extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'color'> {
  name: IconName;
  size?: number;
  color?: keyof typeof COLORS | 'inherit' | (string & {});
  disabled?: boolean;
}

const isColor = (color: string | undefined): color is keyof typeof COLORS =>
  color != null && color in COLORS;

const Icon = ({ name, color, className, disabled, size, onClick }: Props) => (
  <span
    role={onClick ? 'button' : 'img'}
    aria-disabled={disabled}
    aria-label={name}
    className={clsx(`icon-${name}`, styles.icon, className)}
    onClick={onClick}
    style={{
      fontSize: size,
      cursor: onClick ? 'pointer' : undefined,
      color: isColor(color) ? COLORS[color] : color,
    }}
  />
);

export default Icon;
